<!-- Listado de categorias hermanas -->
<div class="row sub-categories-special">
    <div class="col-xs-12 col-sm-3 js-select-grid-view-special sm:order-last">
        <div class="pr-body pl-body">
            <ng-container [ngTemplateOutlet]="selectGridView"></ng-container>
        </div>
    </div>
    <div class="col-sm-3 xs:hidden"></div>
    <div class="col-xs-12 col-sm-6 text-m-0 sub-categories-special-nav">
        <nav class="menu-2categoria tabs">
            <ul
                class="sub-category-limited min-scrollcustom-x pbr-16-32 ptr-16-32"
                *ngIf="siblingCategories as siblings"
                #specialSubcategoryList
                (elementRendered)="scrollToCurrentCategory(specialSubcategoryList)"
            >
                <ng-container *ngIf="siblings?.length > 0">
                    <li
                        class="align-middle"
                        [ngClass]="{
                            'is-active': currentCategoryFromABTest.locationPath === category.locationPath || category.isActive
                        }"
                        *ngFor="let category of siblings; let i = index"
                    >
                        <a
                            class="text-l ttu px-0 blend-link"
                            [href]="category.locationPath"
                            (click)="goToCategory(category, $event)"
                            [title]="category.name + ' ' + lastSectionTranslated"
                        >
                            <div class="text-l ttu" [ngClass]="{ 'has-sibling': subCategories?.length > 0 }">
                                {{ category.name }}
                            </div>
                            <div *ngIf="showDebugCategoryIds">({{ category.id }})</div>

                            <!-- Información de depuración-->
                            <category-debug *ngIf="showDebugCategoryIds" [info]="'(' + category.id + ')'" [template]="'parenthesis'"></category-debug>
                        </a>
                    </li>
                </ng-container>
            </ul>
        </nav>
    </div>
</div>

@defer {
    <category-sub-categories-special-navigation
        [categoryName]="categoryName"
        [subCategories]="subCategories"
        [currentCategoryFromABTest]="currentCategoryFromABTest"
        [lastSectionTranslated]="lastSectionTranslated"
        [showDebugCategoryIds]="showDebugCategoryIds"
        [direction]="direction"
        [showCategoryTitle]="showCategoryTitle"
        (goToCategoryEmitter)="goToCategory($event)"
    ></category-sub-categories-special-navigation>
} @placeholder {
    <div class="pl-body pr-body mbr-8-24 mtr-16-32"></div>
}
